import React, { useMemo } from "react";
import styled from "styled-components";

const PokerModalContainerWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 5010;
  pointer-events: none;
`;

const PokerModalContainer = () => {
  return useMemo(() => {
    return <PokerModalContainerWrapper id="uc-modal-container" />;
  }, []);
};

export default PokerModalContainer;
